import { Table } from 'antd';
import { useTranslation } from "react-i18next";
import TableNumber from "../../../../../atoms/table-number";
import "./market-stress-income-table.scss";

const MarketStressIncomeTable = () => {
    const { t } = useTranslation();

    const columns = [
        {
            title: '',
            dataIndex: 'assets',
            key: 'assets',
            width: 220,
            fixed: "left" as const,
            render: (text: any) => {
                let className
                if (text.title === 'Total Assets' || text.title === 'Total Interest Income') {
                    className = 'bold-blue'
                }

                else if (text.title === 'Net Interest Income') {
                    className = 'bold-green'
                }
                else {
                    className = ''
                }

                return <div className='assets' >
                    <div className={className} >
                        {text.title}
                    </div>
                    {text.subTitle &&
                        <div>
                            <ul>
                                <li>{text.subTitle}</li>
                            </ul>
                        </div>
                    }
                </div>
            }
        },
        {
            title: t("AssetLiability.estimatedFalling"),
            children: [
                {
                    title: 'Ramp(2) -400bps',
                    dataIndex: '400bp1',
                    key: '400bp1',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '-200bp',
                    dataIndex: '200bp1',
                    key: '200bp1',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '-100bp',
                    dataIndex: '100bp1',
                    key: '100bp1',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
        {
            title: t("AssetLiability.estimated12months"),
            dataIndex: 'estimateMonth',
            key: 'estimateMonth',
            //width: 150,
            align: 'center' as const,
            render: (text: string) => <TableNumber value={text} />
        },
        {
            title: t("AssetLiability.estimatedRising"),
            children: [
                {
                    title: '+100bp',
                    dataIndex: '100bp2',
                    key: '100bp2',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '+200bp',
                    dataIndex: '200bp2',
                    key: '200bp2',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: 'Ramp(2) +400bps',
                    dataIndex: '400bp2',
                    key: '400bp2',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
    ];


    let id = 1;
    const data = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Interest Income:",
                "subTitle": ""
            },
            "400bp1": "",
            "200bp1": "",
            "100bp1": "",
            "estimateMonth": "",
            "100bp2": "",
            "200bp2": "",
            "400bp2": ""
        },
        {
            id: id++,
            "key": 2,
            "assets": {
                "title": "Due From Banks & Loan To Banks",
                "subTitle": ""
            },
            "400bp1": "98",
            "200bp1": "98",
            "100bp1": "103",
            "estimateMonth": "143",
            "100bp2": "192",
            "200bp2": "242",
            "400bp2": "410"
        },
        {
            id: id++,
            "key": 3,
            "assets": {
                "title": "Overdraft Loans",
                "subTitle": ""
            },
            "400bp1": "577",
            "200bp1": "577",
            "100bp1": "577",
            "estimateMonth": "577",
            "100bp2": "577",
            "200bp2": "577",
            "400bp2": "577"
        },
        {
            id: id++,
            "key": 4,
            "assets": {
                "title": "Wholesale Loans",
                "subTitle": ""
            },
            "400bp1": "148",
            "200bp1": "148",
            "100bp1": "156",
            "estimateMonth": "253",
            "100bp2": "375",
            "200bp2": "499",
            "400bp2": "852"
        },
        {
            id: id++,
            "key": 5,
            "assets": {
                "title": "Commercial Loans",
                "subTitle": ""
            },
            "400bp1": "1,257",
            "200bp1": "1,582",
            "100bp1": "1,910",
            "estimateMonth": "2,353",
            "100bp2": "2,805",
            "200bp2": "3,258",
            "400bp2": "4,080"
        },
        {
            id: id++,
            "key": 6,
            "assets": {
                "title": "Consumer Loans",
                "subTitle": ""
            },
            "400bp1": "996",
            "200bp1": "996",
            "100bp1": "996",
            "estimateMonth": "996",
            "100bp2": "996",
            "200bp2": "996",
            "400bp2": "996"
        },
        {
            id: id++,
            "key": 7,
            "assets": {
                "title": "Credit Cards",
                "subTitle": ""
            },
            "400bp1": "250",
            "200bp1": "250",
            "100bp1": "250",
            "estimateMonth": "250",
            "100bp2": "250",
            "200bp2": "250",
            "400bp2": "250"
        },
        {
            id: id++,
            "key": 8,
            "assets": {
                "title": "Mortgage Finance",
                "subTitle": ""
            },
            "400bp1": "356",
            "200bp1": "356",
            "100bp1": "356",
            "estimateMonth": "356",
            "100bp2": "356",
            "200bp2": "356",
            "400bp2": "356"
        },
        {
            id: id++,
            "key": 9,
            "assets": {
                "title": "Performing Loans & Advances",
                "subTitle": ""
            },
            "400bp1": "3,584",
            "200bp1": "3,909",
            "100bp1": "4,245",
            "estimateMonth": "4,785",
            "100bp2": "5,360",
            "200bp2": "5,936",
            "400bp2": "7,111"
        },
        {
            id: id++,
            "key": 10,
            "assets": {
                "title": "T-Bills",
                "subTitle": ""
            },
            "400bp1": "143",
            "200bp1": "143",
            "100bp1": "155",
            "estimateMonth": "235",
            "100bp2": "316",
            "200bp2": "398",
            "400bp2": "625"
        },
        {
            id: id++,
            "key": 11,
            "assets": {
                "title": "GDBs",
                "subTitle": ""
            },
            "400bp1": "275",
            "200bp1": "276",
            "100bp1": "281",
            "estimateMonth": "287",
            "100bp2": "293",
            "200bp2": "300",
            "400bp2": "313"
        },
        {
            id: id++,
            "key": 12,
            "assets": {
                "title": "Corporate Bonds",
                "subTitle": ""
            },
            "400bp1": "0",
            "200bp1": "0",
            "100bp1": "0",
            "estimateMonth": "0",
            "100bp2": "0",
            "200bp2": "0",
            "400bp2": "0"
        },
        {
            id: id++,
            "key": 13,
            "assets": {
                "title": "Floating Rate Notes",
                "subTitle": ""
            },
            "400bp1": "25",
            "200bp1": "25",
            "100bp1": "29",
            "estimateMonth": "65",
            "100bp2": "102",
            "200bp2": "139",
            "400bp2": "229"
        },
        {
            id: id++,
            "key": 14,
            "assets": {
                "title": "Zero Coupon Bonds",
                "subTitle": ""
            },
            "400bp1": "2",
            "200bp1": "2",
            "100bp1": "3",
            "estimateMonth": "3",
            "100bp2": "3",
            "200bp2": "3",
            "400bp2": "4"
        },
        {
            id: id++,
            "key": 15,
            "assets": {
                "title": "Certificate of Deposit",
                "subTitle": ""
            },
            "400bp1": "3",
            "200bp1": "3",
            "100bp1": "3",
            "estimateMonth": "6",
            "100bp2": "11",
            "200bp2": "16",
            "400bp2": "29"
        },
        {
            id: id++,
            "key": 16,
            "assets": {
                "title": "International Portfolio",
                "subTitle": ""
            },
            "400bp1": "246",
            "200bp1": "246",
            "100bp1": "246",
            "estimateMonth": "248",
            "100bp2": "251",
            "200bp2": "255",
            "400bp2": "263"
        },
        {
            id: id++,
            "key": 17,
            "assets": {
                "title": "Investment Securities",
                "subTitle": ""
            },
            "400bp1": "696",
            "200bp1": "696",
            "100bp1": "718",
            "estimateMonth": "845",
            "100bp2": "977",
            "200bp2": "1,110",
            "400bp2": "1,463"
        },
        {
            id: id++,
            "key": 18,
            "assets": {
                "title": "Other Assets",
                "subTitle": ""
            },
            "400bp1": "0",
            "200bp1": "0",
            "100bp1": "0",
            "estimateMonth": "0",
            "100bp2": "0",
            "200bp2": "0",
            "400bp2": "0"
        },
        {
            id: id++,
            "key": 19,
            "assets": {
                "title": "Total Interest Income",
                "subTitle": ""
            },
            "400bp1": "4,378",
            "200bp1": "4,703",
            "100bp1": "5,066",
            "estimateMonth": "5,773",
            "100bp2": "6,529",
            "200bp2": "7,288",
            "400bp2": "8,985"
        }
    ];

    const interestData = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Interest Expense:",
                "subTitle": ""
            },
            "400bp1": "",
            "200bp1": "",
            "100bp1": "",
            "estimateMonth": "",
            "100bp2": "",
            "200bp2": "",
            "400bp2": ""
        },
        {
            id: id++,
            "key": 2,
            "assets": {
                "title": "Total Customer Deposit",
                "subTitle": ""
            },
            "400bp1": "-376",
            "200bp1": "-383",
            "100bp1": "-434",
            "estimateMonth": "-866",
            "100bp2": "-1,346",
            "200bp2": "-1,831",
            "400bp2": "-3,030"
        },
        {
            id: id++,
            "key": 3,
            "assets": {
                "title": "Call/Notice Deposits",
                "subTitle": ""
            },
            "400bp1": "0",
            "200bp1": "0",
            "100bp1": "0",
            "estimateMonth": "0",
            "100bp2": "0",
            "200bp2": "0",
            "400bp2": "0"
        },
        {
            id: id++,
            "key": 4,
            "assets": {
                "title": "Time Deposits",
                "subTitle": ""
            },
            "400bp1": "-386",
            "200bp1": "-386",
            "100bp1": "-432",
            "estimateMonth": "-855",
            "100bp2": "-1,327",
            "200bp2": "-1,803",
            "400bp2": "-2,984"
        },
        {
            id: id++,
            "key": 5,
            "assets": {
                "title": "Customer Repos",
                "subTitle": ""
            },
            "400bp1": "11",
            "200bp1": "3",
            "100bp1": "0",
            "estimateMonth": "-4",
            "100bp2": "-7",
            "200bp2": "-10",
            "400bp2": "-18"
        },
        {
            id: id++,
            "key": 5,
            "assets": {
                "title": "Customer Current Accounts",
                "subTitle": ""
            },
            "400bp1": "0",
            "200bp1": "0",
            "100bp1": "-1",
            "estimateMonth": "-6",
            "100bp2": "-12",
            "200bp2": "-17",
            "400bp2": "-27"
        },
        {
            id: id++,
            "key": 6,
            "assets": {
                "title": "Due To Banks",
                "subTitle": ""
            },
            "400bp1": "-15",
            "200bp1": "-15",
            "100bp1": "-17",
            "estimateMonth": "-37",
            "100bp2": "-67",
            "200bp2": "-97",
            "400bp2": "-171"
        },
        {
            id: id++,
            "key": 7,
            "assets": {
                "title": "Debt Security",
                "subTitle": ""
            },
            "400bp1": "-31",
            "200bp1": "-31",
            "100bp1": "-36",
            "estimateMonth": "-71",
            "100bp2": "-106",
            "200bp2": "-141",
            "400bp2": "-220"
        },
        {
            id: id++,
            "key": 8,
            "assets": {
                "title": "Total Interest Expense",
                "subTitle": ""
            },
            "400bp1": "-422",
            "200bp1": "-429",
            "100bp1": "-487",
            "estimateMonth": "-974",
            "100bp2": "-1,520",
            "200bp2": "-2,069",
            "400bp2": "-3,421"
        },
        {
            id: id++,
            "key": 9,
            "assets": {
                "title": "Off Balance Sheet",
                "subTitle": ""
            },
            "400bp1": "0",
            "200bp1": "0",
            "100bp1": "0",
            "estimateMonth": "0",
            "100bp2": "0",
            "200bp2": "0",
            "400bp2": "0"
        },
        {
            id: id++,
            "key": 10,
            "assets": {
                "title": "Net Interest Income",
                "subTitle": ""
            },
            "400bp1": "3,956",
            "200bp1": "4,273",
            "100bp1": "4,580",
            "estimateMonth": "4,799",
            "100bp2": "5,009",
            "200bp2": "5,219",
            "400bp2": "5,565"
        }
    ];

    const incomeAtRiskData = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Net Interest Income At Risk",
                "subTitle": ""
            },
            "400bp1": "-843",
            "200bp1": "-525",
            "100bp1": "-219",
            "estimateMonth": "",
            "100bp2": "210",
            "200bp2": "420",
            "400bp2": "766"
        },
        {
            id: id++,
            "key": 2,
            "assets": {
                "title": "% Change In Net Interest Income",
                "subTitle": ""
            },
            "400bp1": "-0.80%",
            "200bp1": "-2.,63%",
            "100bp1": "-2.57%",
            "estimateMonth": "",
            "100bp2": "2.42%",
            "200bp2": "4.94%",
            "400bp2": "-3.93%"
        }
    ];

    return (
        <div className='market-stress-income-table-wrapper' >
            <div className='market-stress-table-income'>
                <div className="market-stress-table-income__heading">{t("AssetLiability.netRiskTest")}</div>
                <div className="market-stress-table-income__date">05/31/2024 CAD {t("AssetLiability.inMillions")}</div>
                <div className="market-stress-table-income__table" >
                    <Table
                        columns={columns}
                        dataSource={data}
                        bordered
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName={(record, index) => {
                            if (record.key === 1) {
                                return 'market-stress-table-income__bold-white';
                            }
                            else
                                if (record.key === 19) {
                                    return 'market-stress-table-income__bold-blue';
                                }
                                else if (index % 2 === 0) {
                                    return 'market-stress-table-income__table__white';
                                }
                                else {
                                    return 'market-stress-table-income__light-blue';
                                }
                        }}
                        rowKey="id"
                    />
                </div>

                <div className="market-stress-table-income__table liabilities" >
                    <Table
                        columns={columns}
                        dataSource={interestData}
                        bordered
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName={(record, index) => {
                            if (record.key === 1) {
                                return 'market-stress-table-income__bold-white';
                            }
                            else
                                if (record.key === 8) {
                                    return 'market-stress-table-income__bold-blue';
                                }
                                else if (record.key === 9) {
                                    return 'market-stress-table-income__table__white';
                                }
                                else if (record.key === 10) {
                                    return 'market-stress-table-income__green';
                                }
                                else if (index % 2 === 0) {
                                    return 'market-stress-table-income__table__white';
                                }
                                else {
                                    return 'market-stress-table-income__light-blue';
                                }
                        }}
                        rowKey="id"
                    />
                </div>

                <div className="market-stress-table-income__table total-liabilities" >
                    <Table
                        columns={columns}
                        dataSource={incomeAtRiskData}
                        bordered
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName='market-stress-table-income__yellow'
                        rowKey="id"
                    />
                </div>

                <div className='note' >
                    <div>
                        <div className='title' >
                            Note
                        </div>
                        <ul>
                            <li>100bps and 200bps represent parallel shifts of all yield curves</li>
                            <li>Ramp: 12 months period to achieve an Increase of 400bps for all terms.</li>
                            <li>Basel Committee recommends a 200bps parallel shifts for stress testing purpose.</li>
                            <li>Zero is the minimum of any downward shift of yield curves which is why the above stress tests are not symmetrical.</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default MarketStressIncomeTable
